module.exports = {
  APP_VERSION_MAJOR: 7, // Max is 99
  APP_VERSION_MINOR: 25, // Max is 99
  APP_VERSION_PATCH: 0, //  Max is 99
};
